import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { createAssetType } from '@/Pages/Frontend/Components/BlockChain/CreateAsset'

AxiosInterceptor()

const LeaseAssetService = {
  getAllList: async (page: number, sortOrder: string, status: string) => {
    return await axios.get(`station-lease-assets?pageNumber=${page}&sortOrder=${sortOrder}`)
  },

  getSingle: async (uuid: string | undefined) => {
    // return await axios.get(`station-lease-assets?id=${uuid}&pageNumber=1`)
    return await axios.get(`station-lease-assets/${uuid}`)
  },

  create: async (data: createAssetType) => {
    return await axios.post('station-lease-assets', data)
  },
  updateStatus: async (id: string, data: { status: string }) => {
    return await axios.put(`station-lease-assets/${id}`, data)
  },

  traderscardAsigned: async (id: string | undefined, pageNumber: number) => {
    return await axios.get(`station-lease-assets/${id}/tradersCard?pageNumber=${pageNumber}`)
  },
}
export default LeaseAssetService
